import { useState } from 'react';
import { useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

export function JoinWorkspace() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { session } = useAuthStore();
  const token = searchParams.get('token');
  const [stored, setStored] = useState(false);

  if (!token && !session) {
    return <Navigate to="/login" replace />;
  }

  if (!token) {
    return (
      <div className="page-wrapper">
        <div className="app-wrapper">
          <div className="section-verify padding-global">
            <div className="container-small">
              <div className="max-width-medium align-center">
                <div className="card is-verification">
                  <div className="intro-wrapper">
                    <img
                      width={120}
                      loading="lazy"
                      alt="Lima shimmering logo"
                      src="/images/lima-logomark-1_1lima-logomark-1.avif"
                      className="medium-shimmering-logo"
                    />
                    <div className="spacer-medium"></div>
                    <div className="max-width-xsmall align-center">
                      <div className="text-size-medium text-weight-semibold text-colour-dark-brown">
                        Invalid invitation
                      </div>
                    </div>
                    <div className="spacer-xtiny"></div>
                    <div className="text-size-regular text-colour-alt-grey align-center max-width-small">
                      No invitation token provided.
                    </div>
                    <div className="spacer-small"></div>
                    <div className="align-content-middle">
                      <button
                        className="button w-button"
                        onClick={() => navigate(session ? '/overview' : '/login')}
                      >
                        {session ? 'Go to Overview' : 'Go to Login'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleJoinWorkspace = () => {
    sessionStorage.setItem('invite_token', token);
    setStored(true);
    navigate('/signup');
  };

  if (stored) return null;

  return (
    <div className="page-wrapper">
      <div className="app-wrapper">
        <div className="section-verify padding-global">
          <div className="container-small">
            <div className="max-width-medium align-center">
              <div className="card is-verification">
                <div className="intro-wrapper">
                  <img
                    width={120}
                    loading="lazy"
                    alt="Lima shimmering logo"
                    src="/images/lima-logomark-1_1lima-logomark-1.avif"
                    className="medium-shimmering-logo"
                  />
                  <div className="spacer-medium"></div>
                  <div className="max-width-xsmall align-center">
                    <div className="text-size-medium text-weight-semibold text-colour-dark-brown">
                      You've been invited to join a workspace on Lima
                    </div>
                  </div>
                  <div className="spacer-xtiny"></div>
                  <div className="text-size-regular text-colour-alt-grey align-center max-width-small">
                    Click the button below to join the workspace
                  </div>
                  <div className="spacer-small"></div>
                  <div className="align-content-middle">
                    <button
                      className="button w-button"
                      onClick={handleJoinWorkspace}
                    >
                      Join workspace
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
